import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';

/**
 * Pure presentational form fields for AddToJournalDialog.
 * Parent owns the `form` state and `onChange` handler.
 */
const Field = ({ label, children }) => (
  <div>
    <Label className="text-xs">{label}</Label>
    {children}
  </div>
);

const JournalEntryForm = ({ form, onChange }) => {
  const set = (key, value) => onChange({ ...form, [key]: value });

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3">
        <Field label="Side">
          <select
            className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm h-10 mt-1"
            value={form.side}
            onChange={(e) => set('side', e.target.value)}
            data-testid="journal-side-select"
          >
            <option value="buy">Buy / Long</option>
            <option value="sell">Sell / Short</option>
          </select>
        </Field>
        <Field label="Entry Price">
          <Input
            type="number"
            step="0.01"
            value={form.entryPrice}
            onChange={(e) => set('entryPrice', e.target.value)}
            data-testid="journal-entry-price"
          />
        </Field>
        <Field label="Size (shares)">
          <Input
            type="number"
            value={form.size}
            onChange={(e) => set('size', e.target.value)}
            data-testid="journal-size"
          />
        </Field>
        <Field label="Strategy">
          <Input
            placeholder="Breakout, momentum…"
            value={form.strategy}
            onChange={(e) => set('strategy', e.target.value)}
            data-testid="journal-strategy"
          />
        </Field>
        <Field label="Stop Loss">
          <Input
            type="number"
            step="0.01"
            value={form.stopLoss}
            onChange={(e) => set('stopLoss', e.target.value)}
            data-testid="journal-stop-loss"
          />
        </Field>
        <Field label="Take Profit">
          <Input
            type="number"
            step="0.01"
            value={form.takeProfit}
            onChange={(e) => set('takeProfit', e.target.value)}
            data-testid="journal-take-profit"
          />
        </Field>
      </div>
      <Field label="Thesis / Notes">
        <Textarea
          rows={3}
          placeholder="Why are you entering this trade?"
          value={form.thesis}
          onChange={(e) => set('thesis', e.target.value)}
          data-testid="journal-thesis"
        />
      </Field>
    </div>
  );
};

export default JournalEntryForm;
